module.exports = __webpack_public_path__ + "static/media/phoneOtcLogo.a0481bd4.png";